import forEach from 'lodash/forEach';
import { request } from './request';

export const cleanQueryParams = (queryObject: any) => {
  const result: any = {};
  forEach(queryObject, (value: any, key: number | string) => {
    if (value !== null && value !== undefined && value !== '') {
      result[key] = value;
    }
  });

  return result;
};

export const http = (
  method: string,
  url: string,
  headers: any,
  data?: any,
  query?: any,
  files?: Array<any>,
  blobResponse?: boolean,
  arrayResponse?: boolean
) => {
  let rawRequest = request[method](url).set(headers);

  if (blobResponse) {
    rawRequest = rawRequest.responseType('blob');
  }

  if (arrayResponse) {
    rawRequest = rawRequest.responseType('json');
  }

  if (data) {
    rawRequest = rawRequest.send(data);
  }
  if (query) {
    rawRequest = rawRequest.query(cleanQueryParams(query));
  }
  if (files) {
    forEach(files, (file: any, fileName: string) => rawRequest.attach(fileName, file));
  }

  return rawRequest;
};
